/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import {contractService} from "../views/Contracts/services";

const state = {
  contracts: [],
};
const getters = {
  getContracts: (state) => state.contracts,
};
const actions = {
  getContractsAction({ commit }, { currentPage, perPage, sortBy, sortDir }) {
    contractService.fetchContracts(currentPage, perPage, sortBy, sortDir).then(
      (result) => {
        commit("setContracts", result);
      },
      (error) => {
        console.log(error);
      }
    );
  },
};
const mutations = {
  setContracts(state, val) {
    state.contracts = val;
  },
};

export const contract = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
